import React from 'react'

import { asButton } from './asButton'

const UnstyledButton = props => <button {...props} />

const Button = asButton(UnstyledButton)

export { Button }
